import React from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import TemplateSetup from "./Component/TemplateSetup";
import Login from "./Login/Login";
import Dashboard from "./Dashboard/DashboardManagement";
import EditTemplate from "./Component/EditTemplate";
import Campaign from './Campaign/index'
import ImageTesting from "./Component/ImageTesting";
import Sidebar from "./Sidebar/Sidebar";
import ConnectWA from "./ConnectWA/ConnectWAManagement";
import ChatAppManagement from "./Chat/ChatAppManagement";
import SubscriberManagement from "./SubscriberManager/SubscriberManagement";
import Register from "./Register/Register";
import { Toaster } from "react-hot-toast";
import SendTemplateManagement from "./SendTemplateMessage/SendTemplateManagement";
import BroadcastingManagement from "./Broadcasting/BroadcastingManagement";
import ContactManagement from "./Contact/ContactManagement";
import GetTemplateManagement from "./Templates/GetTemplateManagement";
import MessageAppManagement from "./MessageApp/MessageAppManagement";
import TemplateAuth from "./Component/TemplateAuth";
import CreateTemplates from "./Templates/CreateTemplates";
import ForgotPassword from "./Login/ForgotPassword";

import WorkflowUi from "./Component/workFlows/WorkflowUi";
import WorflowsManagement from "./Component/workFlows/WorkFlowsManagement";
import CallPopup from "./Call/call";
import ProtectedRoute from "./Component/ProtectedRoute/ProtectedRoute";
import NotFound from "./NotFound/404";
// import { useAPI } from "./Context/MyContext";


import ManageProfileLayout from "./ManageProfile/ManageProfileLayout";
import ProfileOverview from "./ManageProfile/ProfileOverview";
import TwoFactorAuth from "./ManageProfile/TwoFactorAuth";
import Agents from "./ManageProfile/Agents";




// import BusinessProfile from "./PhoneManagement/BusinessProfile";
// import Verification from "./PhoneManagement/Verification";
// import Templates from "./PhoneManagement/Templates";



import PhoneManagement from "./PhoneManagement/ManagePhone";
import Overview from "./PhoneManagement/Overview";
import QualityLimits from "./PhoneManagement/QualityLimits";
import Calls from "./PhoneManagement/Calls";
import { useAPI } from "./Context/MyContext";
import InactivePage from "./pages/InActive/InactivePage";
import ApiesIntegrationsPage from "./pages/APIES/page";
import SubscriptionExpiredPage from "./pages/SubscriptionExpiredPage/SubscriptionExpiredPage";







const App = () => {
  const { callState, cleanupCall } = useAPI();

  return (
    <>
      {/* Your entire app */}

      {callState && (
        <CallPopup
          callState={callState}
          onEndCall={cleanupCall}
        />
      )}

      <BrowserRouter>
        <MainLayout />
      </BrowserRouter>
    </>
  );
};

const MainLayout = () => {
  const location = useLocation();
  const hideNavbar = location.pathname === "/" || location.pathname === "/campaign";

  return (
    <>

      <Toaster position="top-right" />
      {!hideNavbar}
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Login />} />
        <Route path="/whatapp/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        {/* Inactive Page */}

        <Route path="/inactive" element={<InactivePage />} />
        <Route path="subscription-expired" element={<SubscriptionExpiredPage />} />

        {/* Protected routes */}
        <Route element={<ProtectedRoute />}>
          <Route path="/dashboard" element={<Dashboard />} /> 
          <Route path="/ConnectWA" element={<ConnectWA />} />
          <Route path="/dashboard/Subscriber" element={<SubscriberManagement />} />
          <Route path="/template" element={<GetTemplateManagement />} />
          <Route path="/TemplateSetup" element={<TemplateSetup />} />
          <Route path="/sendbulk" element={<SendTemplateManagement />} />
          <Route path="/edit-template/:templateId" element={<EditTemplate />} />
          <Route path="/campaign" element={<Campaign />} />
          <Route path="/image" element={<ImageTesting />} />
          <Route path="/ChatApp" element={<ChatAppManagement />} />
          <Route path="/Sidebar" element={<Sidebar />} />
          <Route path="/Broadcasting" element={<BroadcastingManagement />} />
          <Route path="/Contacts" element={<ContactManagement />} />
          <Route path="/MessageApp" element={<MessageAppManagement />} />
          <Route path="/TemplateAuth" element={<TemplateAuth />} />
          <Route path="/:wabaId/:phoneNumberId/NewTemplate" element={<CreateTemplates />} />
          <Route path="/workflow" element={<WorflowsManagement />} />
          <Route path="/*" element={<NotFound />} />
          <Route path="/apis" element={<ApiesIntegrationsPage />} />


          {/* MANAGE PROFILE */}

          <Route path="/manage-profile" element={<ManageProfileLayout />}>
            <Route index element={<ProfileOverview />} />
            <Route path="profile" element={<ProfileOverview />} />
            <Route path="2fa" element={<TwoFactorAuth />} />
            <Route path="agents" element={<Agents />} />
          </Route>




          {/* Manage Phone */}
          <Route path="/dashboard/manage-phone/:phoneId" element={<PhoneManagement />}>
            {/* default redirect to overview */}
            <Route index element={<Navigate to="overview" replace />} />
            <Route path="overview" element={<Overview />} />
            <Route path="quality-limits" element={<QualityLimits />} />
            <Route path="calls" element={<Calls />} />
          </Route>





        </Route>
      </Routes>

    </>
  );
};

export default App;


